import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Field } from 'redux-form';
import SelectField from '../SelectField/SelectField';

import '../EmailLayoutsField/EmailLayoutsField.scss';

const PdfLayoutEditLink = ({ input }) => {
    const { t } = useTranslation();

    if (!input.value)
        return null;

    return (
        <div className="EmailLayoutsField-actions">
            <Link
                to={`/layouts/edit/${encodeURIComponent(input.value)}`}
                className="EmailLayoutsField-action btn btn-sm btn-secondary"
                title={t('layouts.references.open_layout')}
            >
                <i className="fa fa-external-link" aria-hidden="true" />
                &nbsp;
                {t('settings.default_layouts.open_model')}
            </Link>
        </div>
    );
};

const PdfLayoutsField = ({ name, options, placeholder, show_edit_link = true }) => {

    const selector = (
        <SelectField
            name={name}
            options={options}
            placeholder={placeholder}
            clearable
        />
    );

    if (!show_edit_link)
        return selector;

    return (
        <div className="EmailLayoutsField EmailLayoutsField--stacked">
            <div className="EmailLayoutsField-select">
                {selector}
            </div>
            <Field name={name} component={PdfLayoutEditLink} />
        </div>
    );
};

export default PdfLayoutsField;
